<div class="az-sidebar sidebar-inner-content">
  <div class="sidebar-inner-content">
    <p-table id="filesList" [scrollable]="true" [lazy]="false" dataKey="fileId" [value]="_mapFiles">
      <ng-template pTemplate="caption">
        <div class="flex search-header">
          <span class="p-input-icon-left col-12">
            <input class="header-search" pInputText type="text" (input)="filter($event)"
                   placeholder="Search keyword"/>
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th colspan="3" style="width:100%;height: 20px;"></th>
          <th style="width:60px;">
            <button class="btn-custom-outlined" (click)="toggleAll()"
                    [style.visibility]="isSearching ? 'hidden' : 'visible'">
              {{ allFilesSelected ? 'Hide' : 'Show' }} all
            </button>
          </th>
        </tr>
      </ng-template>
    </p-table>
    <div class="az-layers">
      @for (mapFile of _mapFiles; track mapFile._id) {
        <ng-container>
          <div class="az-group">
            <div class="group-header">
              <span class="group-title">{{ mapFile.fileName }}</span>
              <a
                style="cursor:pointer;text-decoration: none;margin-top: 3px;align-self: flex-end; color: #1a2124"
                (click)="toggle($event, mapFile)">...
              </a>
              <a (click)="toggleAllAssetsSelect(mapFile)"
                style="cursor:pointer;text-decoration: none;margin-top: 10px; margin-left: 10px;"
                [class]="!areFileAssetsSelected(mapFile) ? 'pi pi-eye-slash' : 'pi pi-eye'">
              </a>

            </div>
          </div>
        </ng-container>
      }
    </div>
  </div>
</div>
<p-popover #op (onHide)="onHidePopOver()" [dismissable]="true">
  <div class="flex flex-col assets-config-op">
    <div>
      <span class="font-medium block mb-2 op-tittle">Select assets</span>
      @if (changingFile) {
        <div class="group-content">
          @for (assetConfig of changingFile.fileAssets; track assetConfig.assetType) {

            <div class="op-layer-info">
              <p-colorPicker
                [appendTo]="'body'"
                [disabled]="!assetConfig.selected"
                [(ngModel)]="assetConfig.color"
                (onChange)="colorChanged($event, assetConfig)">
              </p-colorPicker>
              <span class="layer-name op-asset-name">{{ assetConfig.assetType }}</span>

              <a (click)="toggleSelect(assetConfig)"
                 style="cursor:pointer;text-decoration: none;margin-top: 3px;"
                 [class]="assetConfig.selected ? 'pi pi-eye' : 'pi pi-eye-slash'">
              </a>
            </div>

          }
        </div>
      }

    </div>
  </div>
</p-popover>
